import { Drawer as MDrawer } from '@mantine/core';
import React from 'react';
import './Drawer.scss';

type DrawerProps = {
  opened: boolean;
  title: React.ReactNode | string;
  onClose: (value: boolean) => void;
  children: React.ReactNode;
  trapFocus?: boolean;
  closeOnClickOutside?: boolean;
  className?: string;
  height?: string;
};

export const Drawer = ({
  opened,
  title,
  onClose,
  children,
  trapFocus,
  closeOnClickOutside,
  className,
  height = '50vh',
}: DrawerProps) => (
  <MDrawer
    opened={opened}
    position="bottom"
    onClose={() => {
      onClose(false);
    }}
    withCloseButton={false}
    transitionProps={{
      transition: 'slide-up',
      duration: 300,
      timingFunction: 'ease',
    }}
    title={title}
    overlayProps={{
      color: '#000000',
      opacity: 0.5,
    }}
    trapFocus={trapFocus}
    className={className}
    closeOnClickOutside={closeOnClickOutside}
    closeOnEscape={closeOnClickOutside}
    styles={{
      root: {
        zIndex: 1000,
      },
      content: {
        borderRadius: '24px 24px 0 0 !important',
        height: 'auto !important',
        maxHeight: '80vh',
        minHeight: '20vh',
        overflowY: 'hidden',
      },
      title: {
        marginRight: 0,
        width: '100%',
        paddingTop: '4px',
        paddingLeft: '8px',
        paddingRight: '12px',
      },
      body: {
        maxHeight: height,
        overflowY: 'auto',
        paddingLeft: '24px',
        paddingRight: '24px',
      },
      header: {
        marginBottom: 0,
        paddingBottom: 0,
      },
      inner: {
        zIndex: 1000,
      },
    }}
    // {...otherProps}
  >
    {children}
  </MDrawer>
);
